// src/components/ThankYou.js

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { Link } from 'react-router-dom';
import Reviews from "../components/Reviews";
import ThankYouImage from '../images/thankyou.png'; // Importing the image
const reviews = [
	{
		comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
		rating: 5,
		author: "Name Surname",
		position: "Position",
		company: "Company name",
		image: "https://images.unsplash.com/profile-1441298803695-accd94000cac?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64&s=5a9dc749c43ce5bd60870b129a40902f",
	},
	{
		comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
		rating: 5,
		author: "Name Surname",
		position: "Position",
		company: "Company name",
		image: "https://images.unsplash.com/profile-1441298803695-accd94000cac?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64&s=5a9dc749c43ce5bd60870b129a40902f",
	},
	{
		comment: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
		rating: 5,
		author: "Name Surname",
		position: "Position",
		company: "Company name",
		image: "https://images.unsplash.com/profile-1441298803695-accd94000cac?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64&s=5a9dc749c43ce5bd60870b129a40902f",
	},
];
function ThankYou() {
	const location = useLocation();
	const navigate = useNavigate();
	const { email } = location.state || {};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		if (!email) {
			console.warn("Email is missing; redirecting to home.");
			navigate('/');
		}
	}, [email, navigate]);

	return (
		<div className="flex flex-col min-h-screen">
			{/* Navbar */}
			<Navbar />

			{/* Main Content */}
			<main className="flex-grow flex items-center bg-white justify-center overflow-hidden">
				<div className="max-w-[1440px] py-[112px] px-[20px] w-full text-center">
					<div className='max-w-[496px] mx-auto'>
						{/* Confirmation Icon (Image) */}
						<div className="flex items-center justify-center mb-6">
							<img
								src={ThankYouImage}
								alt="Thank You"
								className="h-[136px] w-[87px]+ object-contain"
							/>
						</div>

						{/* Heading */}
						<h1 className="text-[40px] font-medium text-[#1D1D1D] mb-14">Request Confirmed!</h1>

						{/* Subtitle */}
						<p className="text-gray-700 mb-9 text-left text-2xl font-medium">
							What's Next?
						</p>

						{/* Steps */}
						<div className="space-y-6">
							{/* Step 1 */}
							<div className="flex items-start space-x-4">
								<div
									className="bg-[#699357] broder-[1.5px] border-[#699357] text-white flex items-center justify-center text-xl font-medium rounded-full flex-shrink-0 h-12 w-12"
								>
									1
								</div>
								<p className="text-[#626262] text-left">
									You’ll get a phone call from one of our team members to confirm your order and answer any questions.
								</p>
							</div>

							{/* Step 2 */}
							<div className="flex items-start space-x-4">
								<div
									className="bg-[#699357] broder-[1.5px] border-[#699357] text-white flex items-center justify-center text-xl font-medium rounded-full flex-shrink-0 h-12 w-12"
								>
									2
								</div>
								<p className="text-[#626262] text-left">
									We will request a 50% deposit. Once paid, we will begin processing your order.
								</p>
							</div>

							{/* Step 3 */}
							<div className="flex items-start space-x-4">
								<div
									className="bg-[#699357] broder-[1.5px] border-[#699357] text-white flex items-center justify-center text-xl font-medium rounded-full flex-shrink-0 h-12 w-12"
								>
									3
								</div>
								<p className="text-[#626262] text-left">
									We will stay in constant communication with you until your order arrives safely and you confirm pickup.
								</p>
							</div>
						</div>
					</div>
					<div className='mt-9'>
						<Link
							to="https://www.glass-haus.co"
							className="w-fit bg-[#699357] mt-[32px] text-white text-center text-[24px] py-[8px] px-[16px] rounded-[5px]"
						>
							Go to home
						</Link>
					</div>
				</div>

			</main>
			<Reviews reviews={reviews} />

		</div>

	);
}

export default ThankYou;
